const iban = {
  iban: 'رقم الآيبان',
  ibanTitle: 'الرجاء إدخال رقم الآيبان الخاص بك',
  ibanLabel:
    'يرجى إدخال رقم الآيبان الخاص بصاحب الوثيقة. لن يتم استخدام هذا الآيبان في أي عمليات سحب أو دفع، وإنما سيتم استخدامه فقط في حال وجود مبالغ مستردة لخدمات ما بعد البيع.',
  addIban: 'أضف آيبان',
  noIbansFound: 'لا يوجد رقم آيبان متاح',
  startsWithSA: 'يبدأ بSA',
  includesBankIdentifierCode: 'يحتوى على كود تعريف البنك',
  ibanTotalNumber: 'اجمالى 22 رقم',
  ibanDrawerTitle: 'الرجاء إدخال رقم الآيبان الخاص بك',
  ibanDrawerSubtitle:
    'يرجى إدخال رقم الآيبان الخاص بصاحب الوثيقة. لن يتم استخدام هذا الآيبان في أي عمليات سحب أو دفع، وإنما سيتم استخدامه فقط في حال وجود مبالغ مستردة لخدمات ما بعد البيع.',
  ibanAddedSuccessfully: 'تم إضافة رقم الآيبان بنجاح',
}

export default iban
